import { useNavigate } from "react-router-dom";
import useInView from "../lib/useInView";
import investIMG from "../images/goal-girl.webp";
import couple from '../images/about-img.png';
import sky from '../images/feat-cause.png';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faLandmark,
    faLandmarkDome,
    faLandmarkFlag,
} from "@fortawesome/free-solid-svg-icons";
import homeBg from "../images/about_img.png";
import { Helmet } from "react-helmet";
import mamitoIMG from "../images/mamito.jpeg";
import girlieIMG from "../images/girlie.jpeg";
import broIMG from "../images/bro.jpeg";
import MarketMarquee from "../users/MarketMarquee";
import Market from "../users/Market";


const About = () => {
    const navigate = useNavigate();


    // image animation
    const [boxImageRef, boxImageInView] = useInView({ threshold: 0.5 });
    const [box4Ref, box4InView] = useInView({ threshold: 0.7 });
    const [box6Ref, box6InView] = useInView({ threshold: 0.7 });
    const [boxVidRef, boxVidInView] = useInView({ threshold: 0.5 });
    const [boxSavingRef, boxSavingInView] = useInView({ threshold: 0.5 });
    const [heroRef, heroInView] = useInView({ threshold: 0.5 });
    const [box1Ref, box1InView] = useInView({ threshold: 0.7 });
    const [box7Ref, box7InView] = useInView({ threshold: 0.7 });
    const [box8Ref, box8InView] = useInView({ threshold: 0.7 });
    const [box9Ref, box9InView] = useInView({ threshold: 0.7 });


    return (
        <>
            <Helmet>
                <title>About Us</title>
            </Helmet>

            <div id="hero-section">
                <div className="hero-section">
                    {/* Left Box: Text and Sub-Boxes */}
                    <div className="hero-text-container">
                        <h2 className="hero-description">
                            <span className="circle-text">About Mega Stock Assets</span>
                        </h2>
                        <h1 className="hero-title">
                            Offering A Local Presence, We Bring An International Network To Our Clients.
                        </h1>
                        <div
                            ref={boxSavingRef}
                            className={`sub-container animate__animated ${boxSavingInView ? "animate__flipInX" : ""}`}
                        >
                            <div className="sub-box">Stocks</div>
                            <div className="sub-box">Crypto</div>
                            <div className="sub-box">Investments</div>
                        </div>
                    </div>

                    {/* Right Box: Image */}
                    <div className="hero-image-container">
                        <img
                            src={investIMG}
                            alt="Hero"
                            ref={box1Ref}
                            className={`hero-image animate__animated ${box1InView ? "custom-animation" : ""}`}
                        />
                    </div>
                </div>

                {/* Display Sliding Carousel */}
                <MarketMarquee />
            </div>


            {/* Main About us Section */}
            <div className="two-box-cover">
                <div className="big-box">
                    <h2 className="text-heading">
                        The Mega Assets Foundation
                    </h2>
                    <p className="box-text">
                        At the core of our values is a belief that true success is measured not just in returns, but in the positive impact we create. The Mega Assets Foundation is our commitment to giving back to the communities we serve.
                    </p>
                    <p className="box-text">
                        Our leadership team recognized the importance of supporting causes that matter—beyond investment portfolios. That’s why we’ve launched key initiatives to promote financial literacy, mental well-being, and long-term sustainability through meaningful partnerships.
                    </p>
                    <p className="box-text">
                        Through the Foundation, we provide funding, educational programs, and strategic support in schools and local organizations. To date, we’ve helped raise over $100,000,000 to empower communities and drive awareness in areas like mental health, ethical investing, and digital finance education.
                    </p>
                </div>

                <div className="small-box">
                    <img
                        ref={heroRef}
                        src={sky}
                        alt="e-Node Validator"
                        className={`box-image animate__animated ${heroInView ? "animate__zoomIn" : ""}`}
                    />
                </div>
            </div>


            {/* The sub section */}
            <div className="video-section">
                <div
                    ref={boxVidRef}
                    className={`hero-image-container animate__animated ${boxVidInView ? "animate__zoomIn" : ""}`}
                >
                    <img src={couple} alt="" className="box-image" />

                </div>

                <div className="hero-text-container">
                    <h2 className="box-title"> Cheap, Clarity, and Confidence</h2>
                    <h2 className="hero-title">
                        We want to show you what it’s like to be with a Broker that is Transparent.
                    </h2>

                    <button
                        onClick={() => navigate("/login")}
                        className="delete-button">
                        Get Started
                    </button>
                </div>
            </div>



            {/* three column sections */}
            <div className="heading-cover-bg">
                <div className="last-section">
                    {/* Box 1: Text */}
                    <div className="box">
                        <h2 className="black-title">
                            We Bring Profound Experience And A Professional, Institutional Approach To Finance.
                        </h2>
                        <div className="black-title">
                            We have been working for more than 10 years with major renewable energy project developers on structuring techniques to lower their cost of borrowing. We have also worked with U.S. tax-based as well as economic investors as new entrants into renewable energy for the acquisition of wind farms and solar developments in North America and Europe.
                        </div>
                        <div className="box-text">
                            <h3 className="black-title">
                                Insurance Policies
                            </h3>
                            <p className="black-title">
                                Our Node Validator Insurance solutions protect you against unexpected loss of fund from partial or complete damage to you or your properties.
                            </p>
                        </div>
                    </div>

                    {/* Box 2: Image */}
                    <div className="box">
                        <img
                            src={homeBg}
                            alt="e-Node Validator"
                            ref={boxImageRef}
                            className={`box-image animate__animated ${boxImageInView ? "animate__zoomIn" : ""}`}
                        />
                    </div>

                    {/* Box 3: Icon, Heading, and Text */}
                    <div className="box">
                        <div
                            ref={box6Ref}
                            className={`icon-title-text-container animate__animated ${box6InView ? "animate__zoomInRight" : ""}`}
                        >
                            <FontAwesomeIcon icon={faLandmarkFlag} className="box-icon" />
                            <div
                                className="title-text">
                                <h3 className="box-title black-title">
                                    Skill Management
                                </h3>
                                <div className="black-title">
                                    Cooperating with us, you receives the opportunities for improvement and development of the investments skills.
                                </div>
                            </div>
                        </div>


                        <div
                            ref={box4Ref}
                            className={`icon-title-text-container animate__animated ${box4InView ? "animate__zoomInRight" : ""}`}
                        >
                            <FontAwesomeIcon icon={faLandmarkDome} className="box-icon" />
                            <div className="title-text">
                                <h3 className="box-title black-title">
                                    Systematic Equities
                                </h3>
                                <div className="black-title">
                                    We have collective investment schemes available for qualified investors and also offer our secure investment services.
                                </div>
                            </div>
                        </div>

                        <div
                            ref={box4Ref}
                            className={`icon-title-text-container animate__animated ${box4InView ? "animate__zoomInRight" : ""}`}
                        >
                            <FontAwesomeIcon icon={faLandmark} className="box-icon" />
                            <div className="title-text">
                                <h3 className="box-title black-title">
                                    Stability
                                </h3>
                                <div className="black-title">
                                    Our investment model provides stability, allows us to focus on long-term results and aligns our interests with tour clients.                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

            <Market />
            {/* next content here */}
            <div className="main-box-cover">
                <h2 className="text-heading centered">
                    Giving Back – <span>Building Futures.</span>
                </h2>
                <div className="box-text centered">
                    At Market Power Finance, our mission goes beyond financial returns — we are deeply committed to creating lasting social impact.
                    Through our charitable initiatives and NGO partnerships, we support vulnerable families, underfunded communities, and crisis-affected countries around the world.
                    From funding education and healthcare to providing food, shelter, and emergency aid, we believe that giving back is not just a responsibility — it’s who we are.
                </div>
            </div>


            <div className="last-section">
                <div className="box">
                    <div
                        ref={box9Ref}
                        className={`icon-title-text-container animate__animated ${box9InView ? "animate__zoomInRight" : ""}`}
                    >
                        <img
                            src={girlieIMG}
                            className="boxed-icon"
                            alt="GLOBAL HUMANITARIAN OUTREACH"
                        />
                        <div className="title-text">
                            <h2 className="box-title">
                                GLOBAL HUMANITARIAN OUTREACH
                            </h2>
                            <div className="box-text">
                                We actively collaborate with communities and organizations around the world to support crisis relief, provide food, education, and healthcare, and deliver hope where it's needed most.
                            </div>
                        </div>
                    </div>
                    <h2 className="text-heading centered">
                        Navigate complexity with a trusted capital markets services partner — and a heart for humanity.
                    </h2>
                    <a href="/charity" className="cta-button">
                        Learn More About Our Charity Work
                    </a>
                </div>

                <div className="box">
                    <div
                        ref={box7Ref}
                        className={`icon-title-text-container animate__animated ${box7InView ? "animate__zoomInRight" : ""}`}
                    >
                        <img
                            src={mamitoIMG}
                            className="boxed-icon"
                            alt="ECONOMIC EMPOWERMENT INITIATIVES"
                        />
                        <div className="title-text">
                            <h2 className="box-title">
                                ECONOMIC EMPOWERMENT INITIATIVES
                            </h2>
                            <div className="box-text">
                                We invest in people by supporting small businesses, vocational training, and financial education—empowering individuals and families to build sustainable futures.
                            </div>
                        </div>
                    </div>

                    <div
                        ref={box8Ref}
                        className={`icon-title-text-container animate__animated ${box8InView ? "animate__zoomInRight" : ""}`}
                    >
                        <img
                            src={broIMG}
                            className="boxed-icon"
                            alt="EDUCATION & RESETTLEMENT SUPPORT"
                        />
                        <div className="title-text">
                            <h2 className="box-title">
                                EDUCATION & RESETTLEMENT SUPPORT
                            </h2>
                            <div className="box-text">
                                From scholarships to relocation assistance, we help students and displaced families access quality education and stable environments to restart and thrive.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default About;
